import DadosSessaoService from '@/services/DadosSessaoService'

export const refreshToken = async () => {
  const service = new DadosSessaoService()
  return service.refreshToken()
}
